import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { AuthStore, NotifStore } from '../store/UserStore';
import { CustomDescrypt } from '../utils/MyEncryption';
import { IdleTimerProvider } from 'react-idle-timer';
import NavBd from '../pages/auth/bnd/Nav';
import Home from '../pages/auth/bnd/Home';
import Pencairan, { DataPencairan } from '../pages/auth/bnd/Permintaan/Index';
import FormProviderz from '../pages/auth/bnd/Permintaan/FormProvider';
import Kontrak, { DataKontrak } from '../pages/auth/bnd/kontrak/Index';
import FormKontrak from '../pages/auth/bnd/kontrak/Form';
import DetailKontrak from '../pages/auth/bnd/kontrak/Detail';
import FormAdendum from '../pages/auth/bnd/kontrak/adendum/Form';
import Selesai from '../pages/auth/bnd/Selesai';
import ProsesSp2d from '../pages/auth/bnd/ProssesSp2d/Index';
import FormProces from '../pages/auth/bnd/ProssesSp2d/Form';
import DetailAdendum from '../pages/auth/bnd/kontrak/adendum/Detail';
import { getDatabase, onValue, ref } from 'firebase/database';
// import { firebaseDB } from '../utils/Firebase';

const Bendahara = (props) => {
    const navigate = useNavigate();
    const encryptUser = localStorage.getItem('AuthPersist');
    const encryptUserJson = JSON.parse(encryptUser);
    const decryptedUser = encryptUserJson.state.user === null ? "" : JSON.parse(CustomDescrypt(encryptUserJson.state.user));
    const location = useLocation();
    const [isBendahara, setIsBendahara] = useState(false);
    const logOut = AuthStore((state) => state.logOut);

    // const db = firebaseDB
    const db = getDatabase()
    const pencairan = ref(db, 'pencairan/' + decryptedUser.id_opd);
    const addPemberitahuan = NotifStore((state) => state.addPemberitahuan)

    useEffect(() => {
        onValue(pencairan, (snapshot) => { // monitor firebase
            let juduls = ""
            let nilai = ""
            const data = snapshot.val();
            if (data !== null) {
                if (data.id_opd === decryptedUser.id_opd) {
                    if (data.progres > 1) {
                        juduls = handleLabel(data)
                        nilai = data.anggaran.replaceAll(".", "")

                        addPemberitahuan({
                            judul: juduls,
                            anggaran: rP(nilai),
                            no_spm: data.no_spm,
                            jenis: data.jenis + " " + data.jenis_ls
                        }) // add notif ke store
                    }
                }
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pencairan !== null])

    const rP = (e) => {
        const cur = new Intl.NumberFormat("id-ID", {
            maximumFractionDigits: 0,
            minimumFractionDigits: 0
        }).format(e);
        return cur;
    }

    const handleLabel = (params) => {
        let label = "";

        switch (params.progres) {
            case 2:
                label = "Permintaan ditolak";
                break;
            case 3:
                label = "Permintaan disetujui";
                break;
            case 4:
                label = "Penerbitas SP2D";
                break;
            case 5:
                label = "SP2D Ditandatangani"
                break;
            case 6:
                label = "SP2D Diserahkan";
                break;
            default:
                label = "-";
                break;
        }
        console.log(label);

        return label;
    }

    useEffect(() => {
        if (encryptUser === null || encryptUser === undefined) {
            navigate("/login", { replace: true });
        }
        else {
            if (decryptedUser.user === null) {
                navigate("/login", { replace: true });
            }
            else {
                if (decryptedUser.role !== 'Bendahara') {
                    setIsBendahara(false)
                    navigate("/login", { replace: true });
                }
                else {
                    setIsBendahara(true)
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [encryptUser, location, decryptedUser]);

    const onIdle = () => {
        console.log('on idle');
        handleLogOut();
    }

    const handleLogOut = () => {
        logOut();
        navigate("/", { replace: true });
    }

    if (isBendahara) {
        return (
            <IdleTimerProvider
                timeout={1000 * 60 * 60}
                // onPrompt={onPrompt}
                onIdle={onIdle}
            // onActive={onActive}
            // onAction={onAction}
            >
                <NavBd child={
                    <Routes>
                        <Route exact path='' element={<Home />} />
                        <Route exact path='pencairan' element={<Pencairan />}>
                            <Route exact path='' element={<DataPencairan />} />
                            <Route exact path='add' element={<FormProviderz />} />
                            <Route exact path='edit' element={<FormProviderz />} />
                        </Route>
                        <Route exact path='proses_sp2d'>
                            <Route exact path='' element={<ProsesSp2d />} />
                            <Route exact path='upload' element={<FormProces />} />
                        </Route>
                        {/* <Route exact path='acc' element={<Acc />}>
                            <Route exact path='' element={<DataAcc />} />
                        </Route> */}
                        <Route exact path='selesai' element={<Selesai />} />
                        <Route exact path='kontrak' element={<Kontrak />}>
                            <Route exact path='' element={<DataKontrak />} />
                            <Route exact path='add' element={<FormKontrak />} />
                            <Route exact path='edit' element={<FormKontrak />} />
                            <Route exact path='detail' element={<DetailKontrak />} />
                            <Route exact path='adendum-add' element={<FormAdendum />} />
                            <Route exact path='adendum-edit' element={<FormAdendum />} />
                            <Route exact path='adendum-detail' element={<DetailAdendum />} />
                        </Route>
                    </Routes>
                } onLogOut={handleLogOut} setMode={props.setMode} mode={props.mode} />
            </IdleTimerProvider>
        )
    }
}

export default Bendahara